import request from '@/utils/request'

// APP-腾讯云校验图形验证码
export function checkLegalAndSendMessage(data) {
    return request({
        url: `/survey/vaptchaPC/checkLegalAndSendMessage`,
        method: 'post',
        data
    })
}
// PC端-首页_注册 密码模式
export function pcHomePasswordModelRegister(data) {
    return request({
        url: `/survey/userLogin/pcHomePasswordModelRegister`,
        method: 'post',
        data
    })
}
// PC端-首页_密码登录
export function pcHomePasswordLogin(data) {
    return request({
        url: `/survey/userLogin/pcHomePasswordLogin`,
        method: 'post',
        data
    })
}
// PC端-首页_短信验证码登录 未注册的验证后自动登录
export function pcHomeMessageRegisterOrLogin(data) {
    return request({
        url: `/survey/userLogin/pcHomeMessageRegisterOrLogin`,
        method: 'post',
        data
    })
}
// PC端-首页_忘记密码 校验手机号和验证码
export function pcHomeForgetPassword(data) {
    return request({
        url: `/survey/userLogin/pcHomeForgetPassword`,
        method: 'post',
        data
    })
}
// PC端-首页_用户修改密码
export function pcHomeChangePassword(data) {
    return request({
        url: `/survey/userLogin/pcHomeChangePassword`,
        method: 'post',
        data
    })
}
// PC端-首页_根据用户userId展示用户信息
export function pcHomeShowUserInfo(data) {
    return request({
        url: `/survey/userLogin/pcHomeShowUserInfo`,
        method: 'post',
        data
    })
}
// PC端-首页_更新用户的信息
export function pcHomeUpdateUserInfo(data) {
    return request({
        url: `/survey/userLogin/pcHomeUpdateUserInfo`,
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/login.js